import React from 'react';
import ReactDOM from 'react-dom';
import { ErrorBoundary } from 'react-error-boundary';
import { ConfigProvider } from 'antd';
import enUSIntl from 'antd/lib/locale/en_US';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';

import App from './components/App';
import ErrorFallback from './components/ErrorFallback';

import store from './store';
import { BASE_URL } from './constants/routes';
import './index.css';

ReactDOM.render(
  <ConfigProvider locale={enUSIntl}>
    <Provider store={store}>
      <BrowserRouter basename={BASE_URL}>
        <ErrorBoundary FallbackComponent={ErrorFallback}>
          <App />
        </ErrorBoundary>
      </BrowserRouter>
    </Provider>
  </ConfigProvider>,
  document.getElementById('root')
);
